export const SET_SCROLL_RECORDS = 'SET_SCROLL_RECORDS'
export const UPDATE_SCROLL_RECORDS = 'UPDATE_SCROLL_RECORDS'
export const SET_CURRENT_SCROLL_POSITION = 'SET_CURRENT_SCROLL_POSITION'
